/**
 * Route Configuration
 *
 * Centralized route definitions used by both middleware (proxy.ts)
 * and client-side components for consistent route protection.
 */

/**
 * Routes that require authentication.
 * Users without a valid session will be redirected to login.
 */
export const PROTECTED_ROUTES = [
  '/invitations',
  '/keepsakes',
  '/orders',
  '/account',
  '/settings',
  '/notifications',
  '/export-callback',
  '/oauth-start',
  '/checkout',
] as const

/**
 * Routes only for unauthenticated users.
 * Users with a valid session will be redirected to dashboard.
 */
export const AUTH_ROUTES = ['/login'] as const

/**
 * Check if a pathname matches any protected route
 */
export function isProtectedRoute(pathname: string): boolean {
  return PROTECTED_ROUTES.some((route) => pathname.startsWith(route))
}

/**
 * Check if a pathname matches any auth-only route
 */
export function isAuthRoute(pathname: string): boolean {
  return AUTH_ROUTES.some((route) => pathname.startsWith(route))
}
